import { render, staticRenderFns } from "./deliverManage.vue?vue&type=template&id=527ed14a&scoped=true&"
import script from "./deliverManage.vue?vue&type=script&lang=js&"
export * from "./deliverManage.vue?vue&type=script&lang=js&"
import style0 from "./deliverManage.vue?vue&type=style&index=0&id=527ed14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ed14a",
  null
  
)

export default component.exports